import * as React from "react";
import { Section } from "../Components/Section";
import { ISubTransaction } from "../../Components/Form/Fields/Details/Fields/SubTransactions/SubTransactionsField";
import { DataTable } from "../../../Components/DataTable";
import { Currency } from "../../../../config/currencies";
import "../../../../utils/array_extentions";
import moment from "moment";
import { ITransaction } from "../../../../config/transactions";

interface IExtraSubTransactionsProps {
    value: ISubTransaction[];
    transaction: ITransaction;
}

export const ExtraSubTransactions = ({value, transaction}: IExtraSubTransactionsProps) => {
    const data = value as ISubTransaction[] | any;
    data.sortArrayOfObjectsAsc('date');
    
    const totalAmount = value.reduce((sum, subTransaction) => sum + subTransaction.amount, 0);
    if (totalAmount < transaction.amount) {
        data.push({
            description: 'Remaining amount',
            date: '',
            amount: transaction.amount - totalAmount,
        });
    }

    return (
        <Section title="Sub Transactions" sections={[
            {
                value: (
                    <DataTable
                        sx={{
                            'tr td:first-of-type': {
                                paddingLeft: 0,
                            },
                            'tr:last-of-type td': {
                                paddingBottom: 0,
                            },
                            'tr:last-of-type td:first-of-type': {
                                paddingLeft: 0,
                                ...(
                                    totalAmount < transaction.amount ?
                                    {
                                        fontStyle: 'italic',
                                    } : {}
                                ),
                            },
                            'tr:last-of-type td:last-of-type': {
                                paddingRight: 0,
                            },
                        }}
                        size="small"
                        // hideHeader
                        items={data}
                        config={[
                            {
                                title: 'Description',
                                fieldName: 'description',
                                // component: NameCell,
                                sxHeader: {
                                    fontWeight: 'bold',
                                    paddingTop: 0,
                                    paddingLeft: 0,
                                },
                            },
                            {
                                title: 'Amount',
                                fieldName: 'amount',
                                render(value: any, item: any): any {
                                    return (value as any).toCurrency(Currency.EUR);
                                },
                                sxHeader: {
                                    fontWeight: 'bold',
                                    paddingTop: 0,
                                },
                            },
                            {
                                title: 'Date',
                                fieldName: 'date',
                                render(value: any, item: any): any {
                                    if (value === '') {
                                        return '-';
                                    }
                                    
                                    return moment(value).format('DD/MM/YYYY')
                                },
                                sxHeader: {
                                    fontWeight: 'bold',
                                    paddingTop: 0,
                                },
                            },
                        ]}
                    />
                ),
                noIcon: true,
            }
        ]} />
    );
};
